import React from "react";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import {ThemeType} from "@/theming/baseTheme";
import {useCurrentTheme} from "@/theming/useCurrentTheme";

export interface QuickAction {
    id: string;
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    onPress: () => void;
}

export function QuickActionTile({action}: { action: QuickAction }) {

    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <TouchableOpacity
            key={action.id}
            style={styles.actionCard}
            onPress={action.onPress}
            activeOpacity={0.6}
        >
            <View style={styles.actionIcon}>
                {action.icon}
            </View>
            <Text style={styles.actionTitle}>{action.title}</Text>
            <Text style={styles.actionSubtitle}>{action.subtitle}</Text>
        </TouchableOpacity>
    );
}

const createStyles = (theme: ThemeType) => StyleSheet.create({
    actionCard: {
        flex: 1,
        minWidth: 150,
        backgroundColor: theme.colors.surface,
        borderWidth: 1,
        borderColor: theme.colors.border,
        borderRadius: theme.borderRadius.md,
        padding: theme.spacing.md,
        alignItems: 'center',
    },

    actionIcon: {
        height: 32,
        width: 32,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing.xs,
    },

    actionTitle: {
        fontSize: theme.fontSize.sm,
        fontWeight: '600',
        marginBottom: theme.spacing.xs,
        color: theme.colors.text,
    },

    actionSubtitle: {
        fontSize: theme.fontSize.xs,
        color: theme.colors.textSecondary,
        textAlign: 'center',
    },
});
